import { useRef } from 'react';

const use50Chance = () => {
  const is50Chance = useRef(Math.random() < 0.5);

  return !!is50Chance.current;
};

export default use50Chance;
